import React from 'react';
import { Link } from 'react-router-dom';
import { useSite } from '../../context/SiteContext';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const { settings, headerLinks } = useSite();
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  if (!settings) return null;

  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-sm border-b border-slate-200">
      <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2" data-testid="header-logo">
            <span className="font-heading text-2xl font-bold text-slate-900">
              {settings.site_name}
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {headerLinks.map((link) => (
              <a
                key={link.id}
                href={link.url}
                target={link.is_external ? '_blank' : undefined}
                rel={link.is_external ? 'noopener noreferrer' : undefined}
                className="text-sm font-semibold text-slate-600 hover:text-slate-900 transition-colors"
                data-testid={`header-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="/#order"
              className="btn-cta px-6 py-2 rounded-full text-sm font-bold"
              data-testid="header-cta"
            >
              ORDER NOW
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-200">
            <div className="flex flex-col gap-4">
              {headerLinks.map((link) => (
                <a
                  key={link.id}
                  href={link.url}
                  target={link.is_external ? '_blank' : undefined}
                  rel={link.is_external ? 'noopener noreferrer' : undefined}
                  className="text-sm font-semibold text-slate-600 hover:text-slate-900"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.label}
                </a>
              ))}
              <a
                href="/#order"
                className="btn-cta px-6 py-3 rounded-full text-sm font-bold text-center"
                onClick={() => setMobileMenuOpen(false)}
              >
                ORDER NOW
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
